import { sharedAtom } from '../utilities/jotai-utils';

export const BACKGROUND_OPERATIONS_STATE = sharedAtom('BACKGROUND_OPERATIONS_STATE', {
  data: []
});

export const CLEAR_ENV_STATE = sharedAtom('CLEAR_ENV_STATE', {
  disabled: false
});
